import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarrantyFormat } from "src/models/Products/WarrantyFormat.models";

interface WarrantyFormatState {
  warrantyFormats: IWarrantyFormat[];
  warrantyFormatToEdit: IWarrantyFormat | null;
}

const initialState: WarrantyFormatState = {
  warrantyFormats: [],
  warrantyFormatToEdit: null,
};

const warrantyFormatSlice = createSlice({
  name: "WarrantyFormat",
  initialState,
  reducers: {
    setWarrantyFormatList: (
      state,
      action: PayloadAction<IWarrantyFormat[]>
    ) => {
      state.warrantyFormats = action.payload;
    },
    concatListWarrantyFormat: (
      state: WarrantyFormatState,
      action: PayloadAction<IWarrantyFormat[]>
    ) => {
      state.warrantyFormats = [...state.warrantyFormats.concat(action.payload)];
    },
    setWarrantyFormatToEdit: (
      state,
      action: PayloadAction<IWarrantyFormat | null>
    ) => {
      state.warrantyFormatToEdit = action.payload;
    },
    addWarrantyFormat: (state, action: PayloadAction<IWarrantyFormat>) => {
      state.warrantyFormats.push(action.payload);
    },
    updateWarrantyFormat: (state, action: PayloadAction<IWarrantyFormat>) => {
      let itemIndex = state.warrantyFormats.findIndex(
        item => item.warrantyFormatId === action.payload.warrantyFormatId
      );
      if (itemIndex !== -1) state.warrantyFormats[itemIndex] = action.payload;
    },
    deleteWarrantyFormat: (state, action: PayloadAction<number>) => {
      const newArray = state.warrantyFormats.filter(
        item => item.warrantyFormatId !== action.payload
      );
      state.warrantyFormats = newArray;
    },
  },
});

export const {
  setWarrantyFormatList,
  concatListWarrantyFormat,
  setWarrantyFormatToEdit,
  addWarrantyFormat,
  updateWarrantyFormat,
  deleteWarrantyFormat,
} = warrantyFormatSlice.actions;

export default warrantyFormatSlice.reducer;
